import React, { useState, useRef } from "react";
import {
  SecondaryWrapper,
  SelectStyles,
} from "./LocationAnswerComponent.styled";
import { ALL_COUNTRIES, CITIES_BY_COUNTRY_ID } from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { useLazyQuery, useQuery } from "@apollo/client";
import { Grid } from "@material-ui/core";
import { Col } from "react-bootstrap";
import Select1 from "react-select";
import ModalLoader from "../ModalLoader/ModalLoader";

const LocationAnswerComponent = ({
  keyId,
  componentConfiguration,
  setQualificationLocation,
  idQuestion,
  typeQuestion,
  itsPreview = true,
}) => {
  const [user] = useState(getStateLoginComplete());
  const [allCities, setAllCities] = useState([]);
  const refCountrySelected = useRef();
  const refCitySelected = useRef();
  const [showLoader, setshowLoader] = useState(false);

  const { data: countries } = useQuery(ALL_COUNTRIES, {
    variables: { clientId: user.clientId },
    context: { clientName: "LinkUsers" },
  });

  const [runQueryCitiesByCountry] = useLazyQuery(CITIES_BY_COUNTRY_ID, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data) {
        let cities = data.citiesByCountryId.outputData;
        let resultOfAllCities = cities.map((element) => {
          return {
            ...element,
            value: element?.cityId,
            label: element?.cityName,
          };
        });
        setAllCities(resultOfAllCities);
        setshowLoader(false);
      }
    },
  });

  const [countriesData, setCountriesData] = useState([]);

  let loadCountries = () => {
    if (countries && countriesData.length == 0) {
      let resultOfAllCountries = countries.allCountries.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setCountriesData(resultOfAllCountries);
    }
  };

  let handleChangeCountrySelected = (item) => {
    setshowLoader(true);
    refCitySelected?.current?.clearValue();
    setAllCities(null);
    if (item) {
      runQueryCitiesByCountry({
        variables: { countryId: item.countryId },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  let handleChangeCitySelected = (item) => {
    if (item) {
      let country = refCountrySelected?.current?.getValue();
      let completeObj = `${item.cityName} - ${country[0].countryName}`;
      setQualificationLocation(completeObj, idQuestion, "", typeQuestion);
    }
  };

  return (
    <Col md="12">
      <SecondaryWrapper key={keyId}>
        <Grid container style={{ width: "100%", gap: "22px" }}>
          <Grid item style={{ width: "48%" }}>
            {loadCountries()}
            <Select1
              placeholder="Select a country"
              ref={refCountrySelected}
              styles={SelectStyles}
              options={countriesData}
              onChange={handleChangeCountrySelected}
            />
          </Grid>
          <Grid item style={{ width: "48%" }}>
            <Select1
              placeholder="Select a city"
              ref={refCitySelected}
              options={allCities}
              styles={SelectStyles}
              onChange={handleChangeCitySelected}
            />
          </Grid>
        </Grid>
      </SecondaryWrapper>
      {showLoader && <ModalLoader />}
    </Col>
  );
};

export default LocationAnswerComponent;
